import * as t from "io-ts";
import {
  trailerRouteT,
  trailerRoutesByTrailerIdT,
} from "dora-contracts";

export const routeT = trailerRouteT;
export const routesByTrailerIdT = trailerRoutesByTrailerIdT;

export type Route = t.TypeOf<typeof routeT>;
